import React from "react";

const Label = ({children}) => {
    return (
        <label className={"input-label-pdf pt-1"}>{children}</label>
    )
};

export default Label
